class WordPressApiClient {
  constructor(params) {
    const { baseUri, version, baseRoute, from } = params

    this.baseUri = baseUri
    this.version = version
    this.baseRoute = baseRoute
    this.from = from
  }

  getBaseFetchUrl = () => {
    return `${this.baseUri}/${this.baseRoute}/${this.from}/${this.version}`
  }
}

export default WordPressApiClient


// WEBPACK FOOTER //
// ./src/services/wpapi/client.js